export default function (state: {customer: {type: string}}) {
  return state.customer?.type
}
